export default __webpack_public_path__ + "assets/home-two-three-small.ef52b2991cc1280936a2812b234e3052.png";